export const NAV_COLOUR_ACCENT: Record<string, string> = {
  "navigation-orange": "#FF8200",
  "navigation-blue": "#6679B3",
  "navigation-purple": "#50286F",
  "navigation-turquoise": "#32BAB5",
  "navigation-red": "#AE1F25",
  "navigation-white": "#FFFFFF",
  "navigation-azure": "#3772FF",
  "navigation-green": "#128910",
  "navigation-dark-fuchsia": "#9E0057",
  "navigation-dark-blue": "#24339F",
};
